"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdminCreateDto = void 0;
const admin_1 = require("../admin");
const misc_1 = require("../../../misc");
class AdminCreateDto extends (0, misc_1.generateCreateDto)(admin_1.Admin, ['name', 'username', 'password', 'privileges']) {
}
exports.AdminCreateDto = AdminCreateDto;
